
import { Vue, Component, Prop } from 'vue-property-decorator';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faExternalLinkAlt);

@Component({
  components: {
    FontAwesomeIcon,
  },
})
export default class NavbarItem extends Vue {
  @Prop({ required: true }) title!: string;
  @Prop({ default: '' }) description!: string;
  @Prop({ default: null }) icon!: string | [string, string] | null;
  @Prop({ required: true }) href!: string;
  @Prop({ default: null }) target!: string | null;
  @Prop({ default: null }) rel!: string | null;

  get hasIcon(): boolean {
    return this.icon !== null;
  }

  get isExternal(): boolean {
    try {
      return (
        new URL(this.href, window.location.origin).host !== window.location.host
      );
    } catch {
      return false;
    }
  }

  get relValue(): string | null {
    if (this.isExternal) {
      return this.rel ?? 'noopener noreferrer';
    }
    return this.rel;
  }
}
